import { Component, OnInit, Input, ChangeDetectorRef, Inject, SimpleChanges, ElementRef } from '@angular/core';
import { TyphographyComponent } from './bookEditOptionPopups/text/typhography/typhography.component';
import { PagenopositionComponent } from './bookEditOptionPopups/pagenoposition/pagenoposition.component'
import { ColorPickerComponent } from "../../bookShared/popups/colorPicker/colorPicker.component";
import { FillupquestionComponent } from './bookEditOptionPopups/question/fillupquestion/fillupquestion.component';
import { TruefalsequestionComponent } from './bookEditOptionPopups/question/truefalsequestion/truefalsequestion.component';
import { SymbolComponent } from './bookEditOptionPopups/text/symbol/symbol.component';
import { InlineimageComponent } from "./bookEditOptionPopups/text/media/inlineimage/inlineimage.component";
import { TextimageComponent } from "./bookEditOptionPopups/text/media/textimage/textimage.component";
import { MediacategoriesComponent } from "./bookEditOptionPopups/mediacategories/mediacategories.component";
import { PagebackgroundcolorComponent } from "./bookEditOptionPopups/pagebackgroundcolor/pagebackgroundcolor.component";
import { ImageGallerymediaComponent } from "./bookEditOptionPopups/media/image/imageGallerymedia/imageGallerymedia.component";
import { VideogallerymediaComponent } from "./bookEditOptionPopups/media/video/videogallerymedia/videogallerymedia.component"
import { Book } from '../../shared/models/book';
import { BookData } from '../../shared/models/bookData';
import { EnrichmentPage } from '../../shared/models/enrichmentPage';
import { EditorService } from '../bookeditoption/editor.service';
import { AudiomediaComponent } from '../bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component';
import { Page } from '../../shared/models/page';
import { EditOptionService } from './editOptions.service';
import { PageContent } from '../../shared/models/pageContent';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ShapecolorComponent } from '../bookeditoption/bookEditOptionPopups/text/shapecolor/shapecolor.component';
import { UrlComponent } from '../bookeditoption/bookEditOptionPopups/media/url/url.component';
import { MultipleselectComponent } from './bookEditOptionPopups/question/multipleselect/multipleselect.component';
import { FillupwithoptionComponent } from './bookEditOptionPopups/question/fillupwithoption/fillupwithoption.component';
import { DrawingcardcolorComponent } from './bookEditOptionPopups/drawingcardcolor/drawingcardcolor.component';
import * as _ from 'lodash';
@Component({
  selector: 'app-bookeditoption',
  templateUrl: './bookeditoption.component.html',
  styleUrls: ['./bookeditoption.component.css']
})
export class BookeditoptionComponent implements OnInit {
  @Input() bookObj: Book;
  @Input() bookDataObj: BookData;
  @Input() currentLoadingPage: EnrichmentPage;
  @Input() pageObj: Page;
  @Input() rootTabActive: boolean;
  @Input() pageContent: PageContent;
  @Input() parent;
  updatedIcon;
  selectedOption;
  gotoBack;
  displayAddMoreComp;
  selectCate = false;
  globalPopupPara: any = {};
  clickStatus;
  dialogData;
  cardtype;
  toogleLivePreciew = false;
  showAlertPopup = false;
  curInd;
  drawingCardMode = true;
  subsCribe;
  popupParams: any = {
    height: 300,
    width: 300,
    direction: "right",
    arrowPos: 50,
    showPopup: false,
    loadDirective: "",
    curComp: this
  };


  constructor(private editorService: EditorService, private cdr: ChangeDetectorRef, public dialog: MatDialog, private editorOptionsService: EditOptionService, private ele: ElementRef) {

    this.editorService.bookOption$.subscribe(
      data => {
        if (!this.toogleLivePreciew) {
          if (data == "pagePreview") {
            this.exitToInitialState();
            return;
          }
          setTimeout(() => {
            this.openPopupFromObj(data);
          }, 0);
        }

      });
  }
  ngOnDestroy() {
    this.subsCribe.unsubscribe();
  }
  ngOnInit() {

    //console.log("sadasdasdadasd:" + this.currentLoadingPage.isPage)
    this.subsCribe = this.editorService.editorData$.subscribe(evt => {
      this.clickStatus = evt;
      if (!this.toogleLivePreciew) {
        this.updateLeftMenu(evt);
      }
      if (evt.type == "IMAGE" || evt.type == "VIDEO" || evt.type == "AUDIO" || evt.type == "VIDEOYT" || evt.type == "URLLOAD") {
        if (!this.toogleLivePreciew) {
          setTimeout(() => {
            this.openPopupFromObj(evt);
          }, 0);
        }
      }
    });
  }

  //While Switching between tabs
  ngOnChanges(changes: SimpleChanges) {
    this.exitToInitialState();
    this.toogleLivePreciew = false;
  }

  tempMoreIconsList = [
    { icon: "icon-Text", state: "text" },
    { icon: "icon-Media", state: "media" },
    { icon: "icon-Shape", state: "shapes" },
    { icon: "icon-Background-New", state: "background" },
    { icon: "icon-Page-No", state: "pageNumber" },
    //{ icon: "icon-Mindmap", state: "mindmap" },
    { icon: "icon-Drawing-New", state: "drawing" }
  ];
  moreIconsList = this.tempMoreIconsList;

  subIconsList = {
    text: [
      { icon: "icon-Add-Text", state: "addnewtext" },
      { icon: "icon-Text-Style", state: "typography" },
      { icon: "icon-Text-Media", state: "textmedia" },
      { icon: "icon-QuestionMarkNew", state: "textquestion" },
      { icon: "icon-Symbols", state: "symbol" },
      { icon: "icon-Shapes-Color", state: "shapeColor" },
    ],
    media: [
      { icon: "icon-Image", state: "image" },
      { icon: "icon-Video", state: "video" },
      { icon: "icon-Audio-line", state: "audio" },
      { icon: "icon-Browser", state: "mediaweb" }
    ],
    background: [
      { icon: "icon-BackgroundImage", state: "pageBgImage" },
      { icon: "icon-BackgroundColour", state: "pageBgColor" },
      { icon: "icon-Apply-to-All-Backgrounds", state: "ApplyBackgroundToAll" },
      { icon: "icon-Page-Clean", state: "PageBgClear" },
      { icon: "icon-Reset-All-Backgrounds", state: "resetBackgroundAll" }
    ],
    pagenumberopt: [
      { icon: "icon-Page-No-Position", state: "pageNoSetting" },
      { icon: "icon-Apply-to-all-pages", state: "ApplyForAllPageNo" },
      { icon: "icon-Reset-Current-Page", state: "resetCurrentPageNo" },
      { icon: "icon-Reset-All-page", state: "resetAllPageNo" },
    ],
    bgImageOption: [
      { icon: "icon-Background-Image-new-Configure", state: "bgImgGallery" },
      // { icon: "icon-Aspect_ratio", state: "bgImgAspectRatio" },
      // { icon: " icon-ImageRotate", state: "bgImgRotation" }
    ],
    browseOption: [
      { icon: "icon-Add-Image-Main", state: "addnewImage" },
      { icon: "icon-Image-Configure", state: "imageGallery" },
    ],
    browseVideoOption: [
      { icon: "icon-Add-Video", state: "addnewVideo" },
      { icon: "icon-Video-Configure", state: "videoGallery" },
    ],
    shapes: [
      { icon: "icon-Rectangle", state: "shpRectangle" },
      { icon: "icon-Circle", state: "shpCircle" }
    ],
    drawing: [
      { icon: "icon-Add-drawing-new", state: "addDrawingCard" },
      { icon: "icon-Enable-drawing-new", state: "ebableDrawing" },
      { icon: "icon-Drawing-config", state: "configDrawing" },
      { icon: "icon-Eraser", state: "eraseDrawing" }
    ],
    textQuestionOpt: [
      { icon: "icon-Text-Fillup", state: "Fillup" },
      { icon: "icon-Text-True-r-False", state: "TrueFalse" },
      { icon: "icon-Text-MultiChoice", state: "MultiChoice" },
      { icon: "icon-Text-FillupOption", state: "FillupOption" }
    ],
    textQuestionFillup: [
      { icon: "icon-Text-Fillup-Add", state: "addNewFillup" },
      { icon: "icon-Text-Fillup-Configure", state: "addFillupMedia" },
    ],
    textQuestionTrueFalse: [
      { icon: "icon-Add-Text-True-r-False", state: "addNewTrueFalse" },
      { icon: "icon-Text-True-r-False-Configure", state: "addTrueFalseMedia" }
    ],
    textQuestionMultiChoice: [
      { icon: "icon-Add-Text-MultiChoice", state: "addNewMultiChoice" },
      { icon: "icon-Text-MultiChoice-Configure", state: "addMultiChoiceMedia" }
    ],
    textQuestionFillupOption: [
      { icon: "icon-Add-Text-FillupOption", state: "addNewFillupOption" },
      { icon: "icon-Text-FillupOption-Configure", state: "addFillupOptionMedia" }
    ],
    mediaAudioOpt: [
      { icon: "icon-Add-Audio-line", state: "addNewAudio" },
      { icon: "icon-Audio-line-Configure", state: "audioMediaConfig" }
    ],
    mediaUrlOpt: [
      { icon: "icon-AddUrl", state: "addMediaurl" },
      { icon: "icon-Brows-URL", state: "mediaUrlInput" }
    ],
    textmediaOpt: [
      { icon: "icon-Text-Image", state: "TextMediaImage" },
      { icon: "icon-Text-Inline-Image", state: "textMediaInlineImage" }
    ],
    TextMediaImageOpt: [
      { icon: " icon-Add-Text-Image", state: "addTextMediaImage" },
      { icon: "icon-Text-Image-Configure", state: "textMediaImageConfig" }
    ],
    textMediaInlineImageOpt: [
      { icon: "icon-Add-Text-Inline-Image", state: "addtextMediaInlineImage" },
      { icon: "icon-Text-Inline-Image-Configure", state: "textMediaInlineImageConfig" }
    ]
  };

  // To return Back stage 
  displayMoreOptions() {
    this.updatedIcon = "icon-CollectionTemplatesL";
    if (this.selectedOption == "image" || this.selectedOption == "video" || this.selectedOption == "audio" || this.selectedOption == "mediaweb") {
      this.moreIconsList = this.subIconsList.media;
      this.updatedIcon = "icon-Media-Back";
      this.selectedOption = "";
      return;
    } else if (this.selectedOption == "pageBgImage") {
      this.moreIconsList = this.subIconsList.background;
      this.updatedIcon = "icon-Background-New-Back";
      this.selectedOption = "background";
      return;
    }
    else if (this.selectedOption == "textquestion" || this.selectedOption == "textmedia") {
      this.moreIconsList = this.subIconsList.text;
      this.updatedIcon = " icon-Text-Back";
      this.selectedOption = "text";
      return;
    }
    else if (this.selectedOption == "Fillup" || this.selectedOption == "TrueFalse" || this.selectedOption == "MultiChoice" || this.selectedOption == "FillupOption") {
      this.moreIconsList = this.subIconsList.textQuestionOpt;
      this.updatedIcon = "icon-Text-Question-Back";
      this.selectedOption = "textquestion";
      return;
    }
    else if (this.selectedOption == "TextMediaImage" || this.selectedOption == "textMediaInlineImage") {
      this.moreIconsList = this.subIconsList.textmediaOpt;
      this.updatedIcon = " icon-Text-Media-Back";
      this.selectedOption = "textmedia";
      return;
    }
    else if (this.gotoBack) {
      this.moreIconsList = this.tempMoreIconsList;
      this.gotoBack = false;
      return;
    }
    if (this.displayAddMoreComp) {
      this.displayAddMoreComp = false;
      this.SwitchToPreview();
    } else {
      this.displayAddMoreComp = true;
      this.editorService.getEditorData('editable');
    }



  }


  isShowPageNumber(icon) {
    var isShow: boolean = false;
    if (icon.state == "pageNumber" || icon.state == "ApplyBackgroundToCurrent" || icon.state == "ApplyBackgroundToAll" || icon.state == "resetBackgroundAll") {
      if (this.bookObj.bookCategory == 1 && this.rootTabActive)
        isShow = true;
      else
        isShow = false;
      //if(isCreadteebe ==true roottabactive ==true)
    }
    else {
      isShow = true;
    }
    return isShow;
  }

  isShowshapesIcon(icon) {
    var isShowShape: boolean = false;
    if (icon.state == "shapeColor") {
      if (this.clickStatus && this.clickStatus.shape)
        isShowShape = true;
      else
        isShowShape = false;
    }
    else {
      isShowShape = true;
    }
    return isShowShape;
  }

  isShowDrawingIcon(icon) {
    var isShowDrawing: boolean = false;
    if (!this.drawingCardMode && (icon.state == "configDrawing" || icon.state == "eraseDrawing")) {
      return isShowDrawing = false;

    } else if (!this.drawingCardMode && !(icon.state == "configDrawing" || icon.state == "eraseDrawing")) {
      return isShowDrawing = true;
    }

    if (icon.state == "ebableDrawing" || icon.state == "configDrawing" || icon.state == "eraseDrawing") {
      if (this.cardtype == "DRAWING" && this.drawingCardMode) {
        isShowDrawing = true;
      }
      else {
        isShowDrawing = false;
      }
    }
    else {
      isShowDrawing = true;
    }
    return isShowDrawing;
  }

  isShowTextIcon(icon) {
    var isShowTextIcons: boolean = false;
    if (icon.state == "typography" || icon.state == "textmedia" || icon.state == "textquestion" || icon.state == "symbol" || icon.state == "imageGallery" || icon.state == "videoGallery" || icon.state == "audioMediaConfig" || icon.state == "mediaUrlInput" || icon.state == "addFillupMedia" || icon.state == "addTrueFalseMedia" || icon.state == "addMultiChoiceMedia" || icon.state == "addFillupOptionMedia" || icon.state == "textMediaImageConfig" || icon.state == "textMediaInlineImageConfig") {


      if ((this.cardtype == "TEXT" && (icon.state == "typography" || icon.state == "textmedia" || icon.state == "textquestion" || icon.state == "symbol")) || (this.cardtype == "IMAGE" && icon.state == "imageGallery") || (this.cardtype == "VIDEO" && icon.state == "videoGallery") || (this.cardtype == "AUDIO" && icon.state == "audioMediaConfig") || (this.cardtype == "URLLOAD" && icon.state == "mediaUrlInput") || (this.cardtype == "FillBlank" && icon.state == "addFillupMedia") || (this.cardtype == "TrueFalse" && icon.state == "addTrueFalseMedia") || (this.cardtype == "MultiChoice" && icon.state == "addMultiChoiceMedia") || (this.cardtype == "FillupOption" && icon.state == "addFillupOptionMedia") || (this.cardtype == "Image" && icon.state == "textMediaImageConfig") || (this.cardtype == "Inline Image" && icon.state == "textMediaInlineImageConfig"))
        isShowTextIcons = true;
      else
        isShowTextIcons = false;
    }
    else {
      isShowTextIcons = true;
    }
    return isShowTextIcons;
  }


  updateLeftMenu(cardObj) {
    if (!this.displayAddMoreComp) {
      this.displayAddMoreComp = true;
    }
    if (this.clickStatus && this.clickStatus.type) {
      this.cardtype = this.clickStatus.type;
    }
    let com = this.editorService.getIframeReference();
    if (cardObj == "reset") {
      this.cardtype = cardObj;
      this.exitToLevelFirst();
      this.cdr.detectChanges();
      this.curInd = undefined;
      this.drawingCardMode = false;
      com.setDrawingCardMoveState(this.drawingCardMode);
    }
    if (cardObj == "delete") {
      this.cardtype = cardObj;
      this.exitToLevelFirst();
      this.cdr.detectChanges();
      this.curInd = undefined;
    }

    if (cardObj) {
      if (cardObj.type == "TEXT") {
        this.updateSubLevelIocns('text', '');
      }
      else if (cardObj.type == "IMAGE") {
        this.updateSubLevelIocns('image', '');
      }
      else if (cardObj.type == "AUDIO") {
        this.updateSubLevelIocns('audio', '');
      }
      else if (cardObj.type == "VIDEO" || cardObj.type == "VIDEOYT") {
        this.updateSubLevelIocns('video', '');
      }
    }
    if (cardObj.type == "Image") {
      this.updateSubLevelIocns('TextMediaImage', '');
    }
    else if (cardObj.type == "Inline Image") {
      this.updateSubLevelIocns('textMediaInlineImage', '');
    }
    else if (cardObj.type == "FillBlank") {
      this.updateSubLevelIocns('Fillup', '');
    }
    else if (cardObj.type == "TrueFalse") {
      this.updateSubLevelIocns('TrueFalse', '');
    }
    else if (cardObj.type == "MultiSelect") {
      this.cardtype = "MultiChoice";
      this.updateSubLevelIocns('MultiChoice', '');
    }
    else if (cardObj.type == "Select") {
      this.cardtype = "FillupOption";
      this.updateSubLevelIocns('FillupOption', '');
    }
    else if (cardObj.type == "URLLOAD") {
      this.updateSubLevelIocns('mediaweb', '');
    }
    else if (cardObj.type == "DRAWING") {
      this.updateSubLevelIocns('drawing', '');
      this.drawingCardMode = true;
      com.setDrawingCardMoveState(this.drawingCardMode);
    }
    // if (cardObj != 'editable' && cardObj != 'pagePreview' && cardObj != "reset") {
    // if (!this.cdr.detectChanges['destroyed']) {
    //  this.cdr.detectChanges();
    // this.moreIconsList = this.moreIconsList;
    // }
    //  }

  }


  //To update next level Data
  updateSubLevelIocns(state, evt) {
    if (this.toogleLivePreciew && evt) {
      evt.stopPropagation();
      this.showCardAlert(evt, 'Editor Mode');
      return;
    }
    this.gotoBack = true;
    let com = this.editorService.getIframeReference();
    if (state == "addnewtext" || state == "shpRectangle" || state == "shpCircle") {
      this.cardtype = "TEXT";
      if (state == "addnewtext")
        com.addElementsToStage('TEXT');
      // setTimeout(() => {
      //   this.saveTemplate();
      // }, 100);
    } else if (state == "text") {
      this.updatedIcon = "icon-Text-Back";
      this.moreIconsList = this.subIconsList.text;
      if (evt) {
        com.addElementsToStage('TEXT');
      }
    } else if (state == "textmedia") {
      this.moreIconsList = this.subIconsList.textmediaOpt;
      this.updatedIcon = " icon-Text-Media-Back";
      this.selectedOption = "textmedia";
    } else if (state == "media") {
      this.moreIconsList = this.subIconsList.media;
      this.updatedIcon = "icon-Media-Back";
    } else if (state == "image") {
      this.moreIconsList = this.subIconsList.browseOption;
      this.updatedIcon = "icon-Image-Back";
      this.selectedOption = "image";
      if (evt) {
        com.addElementsToStage('IMAGE');
      }
    } else if (state == "video") {
      this.moreIconsList = this.subIconsList.browseVideoOption;
      this.updatedIcon = "icon-Video-Back";
      this.selectedOption = "video";
      if (evt) {
        com.addElementsToStage('VIDEO');
      }
    } else if (state == "shapes") {
      this.moreIconsList = this.subIconsList.shapes;
      this.updatedIcon = "icon-Shape-Back";
      this.selectedOption = "shapes";
    } else if (state == "drawing") {
      this.moreIconsList = this.subIconsList.drawing;
      this.updatedIcon = "icon-Drawing-Back";
      this.selectedOption = "drawing";
      this.drawingCardMode = true;
      if (evt) {
        com.addElementsToStage('DRAWING');
      }
    }
    else if (state == "audio") {
      this.moreIconsList = this.subIconsList.mediaAudioOpt;
      this.updatedIcon = " icon-Audio-Back";
      this.selectedOption = "audio";
      if (evt) {
        com.addElementsToStage('AUDIO');
      }
    }
    else if (state == "mediaweb") {
      this.moreIconsList = this.subIconsList.mediaUrlOpt;
      this.updatedIcon = " icon-UrlBack";
      this.selectedOption = "mediaweb";
      if (evt) {
        com.addElementsToStage('URLLOAD');
      }
    }
    else if (state == "background") {
      this.moreIconsList = this.subIconsList.background;
      this.updatedIcon = "icon-Background-New-Back";
      this.selectedOption = "background";
    }
    else if (state == "pageBgImage") {
      this.moreIconsList = this.subIconsList.bgImageOption;
      this.updatedIcon = "icon-Image-Back";
      this.selectedOption = "pageBgImage";
    }
    else if (state == "pageNumber") {
      this.moreIconsList = this.subIconsList.pagenumberopt;
      this.updatedIcon = "icon-Page-No-Back";
      this.selectedOption = "pageNumber";
    }
    else if (state == "textquestion") {
      this.moreIconsList = this.subIconsList.textQuestionOpt;
      this.updatedIcon = "icon-Text-Question-Back";
      this.selectedOption = "textquestion";
    }
    else if (state == "Fillup") {
      this.moreIconsList = this.subIconsList.textQuestionFillup;
      this.updatedIcon = "icon-Text-Fillup-Back";
      this.selectedOption = "Fillup";
      if (evt) {
        com.addQuestionToContent(0);
      }
    } else if (state == 'TrueFalse') {
      this.moreIconsList = this.subIconsList.textQuestionTrueFalse;
      this.updatedIcon = "icon-Text-True-r-False-Back";
      this.selectedOption = "TrueFalse";
      if (evt) {
        com.addQuestionToContent(1);
      }
    }
    else if (state == 'MultiChoice') {
      this.moreIconsList = this.subIconsList.textQuestionMultiChoice;
      this.updatedIcon = "icon-Text-MultiChoice-Back";
      this.selectedOption = "MultiChoice";
      if (evt) {
        com.addQuestionToContent(2);
      }
    }
    else if (state == 'FillupOption') {
      this.moreIconsList = this.subIconsList.textQuestionFillupOption;
      this.updatedIcon = "icon-Text-FillupOption-Back";
      this.selectedOption = "FillupOption";
      if (evt) {
        com.addQuestionToContent(3);
      }
    }
    else if (state == 'TextMediaImage') {
      this.moreIconsList = this.subIconsList.TextMediaImageOpt;
      this.updatedIcon = "icon-Text-Image-Back";
      this.selectedOption = "TextMediaImage";
      if (evt) {
        com.addMediaToContent(0);
      }
    }
    else if (state == 'textMediaInlineImage') {
      this.moreIconsList = this.subIconsList.textMediaInlineImageOpt;
      this.updatedIcon = " icon-Text-Inline-Image-Back";
      this.selectedOption = "textMediaInlineImage";
      if (evt) {
        com.addMediaToContent(1);
      }
    }
    else if (state == "ApplyBackgroundToAll") {
      var self = this;
      this.editorOptionsService.getPageContent(this.pageObj.contentDocId).then(function (res) {
        if (res) {
          self.editorOptionsService.applyPageBgStyleToAllPages(res['pageContent'], self.bookDataObj, self.parent);
        }
      });
    }
    else if (state == "PageBgClear") {
      var self = this;
      if (this.bookObj.bookCategory == 0) {
        com.resetPageBg(true);
      }
      else {
        if (this.rootTabActive) {
          if (!this.pageObj.isCustomBg) {
            com.resetPageBg(true);
          }
          else if (this.pageObj.isCustomBg && this.pageObj.type == 'blankPage')
            this.editorOptionsService.resetPageBgStyleToCurrentPage(this.pageObj, this.bookDataObj, this.bookObj, this.parent);
        }
        else {
          com.resetPageBg(true);
        }
      }


    }
    else if (state == "resetBackgroundAll") {
      this.editorOptionsService.resetPageBgStyleToAllPages(this.bookDataObj, this.bookObj, this.parent);
    }
    else if (state == "ApplyForAllPageNo") {
      var self = this;
      this.editorOptionsService.getPageContent(this.pageObj.contentDocId).then(function (res) {
        if (res) {
          self.editorOptionsService.applyPageNoToAllPages(res['pageContent'], self.bookDataObj, self.parent);
        }
      });
    }
    else if (state == "resetCurrentPageNo") {
      let pageNo = this.pageObj.pageNumber;
      let obj: any = {
        'value': pageNo,
        'visible': 'false',
        'position': ''
      }
      com.setPageNumber(obj);

    }
    else if (state == "resetAllPageNo") {
      this.editorOptionsService.resetPageNoToAllPages(this.bookDataObj, this.parent);
    }

    if (evt) {
      this.showPopupForBook(state, evt);
    } else {
      this.cdr.detectChanges();
    }
  }


  // To showing to the Diffent popoup
  showPopupForBook(state, evt) {
    let com = this.editorService.getIframeReference();
    this.popupParams.height = 350;
    this.popupParams.width = 300;
    this.popupParams.arrowPos = 150;
    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.ev = evt;

    //For restricting without selecting the text Card.

    if (state == "typography") {
      let textSelect = com.checkTextSelection();
      if (textSelect == false) {
        this.showCardAlert(evt, 'Text from Text Card');
        return;
      }
      this.globalPopupPara.showPopup = true;
      this.popupParams.height = 350;
      this.popupParams.loadDirective = TyphographyComponent;
    }
    if (state == "shpRectangle") {
      setTimeout(() => {
        com.addShapeCard('Rectangle');
      }, 20);

    }
    if (state == "shpCircle") {
      setTimeout(() => {
        com.addShapeCard('connector');
      }, 20);
    }


    //For Adding and Configure the Image To Text
    if (state == "addTextMediaImage") {
      this.cardtype = "Image";
      this.editorService.textInlineData = "";
      com.addMediaToContent(0);
    }
    else if (state == "textMediaImageConfig" && (this.cardtype == "Image" || this.cardtype == "Media")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = TextimageComponent;
      this.popupParams.height = 400;
      this.popupParams.width = 350;
    }

    //For Adding And Configure the inline image to Text
    else if (state == "addtextMediaInlineImage") {
      this.cardtype = "Inline Image";
      this.editorService.textInlineData = "";
      com.addMediaToContent(1);
    }
    else if (state == "textMediaInlineImageConfig" && (this.cardtype == "Inline Image" || this.cardtype == "Media")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = InlineimageComponent;
      this.popupParams.height = 400;
      this.popupParams.width = 350;
    }

    if (state == 'addNewFillup') {
      this.cardtype = "FillBlank";
      this.editorService.textInlineData = "";
      com.addQuestionToContent(0);
    }
    else if (state == "addFillupMedia" && this.cardtype == "FillBlank") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = FillupquestionComponent;
      this.popupParams.height = 200;
      this.popupParams.arrowPos = 100;
    }
    if (state == 'addNewTrueFalse') {
      this.cardtype = "TrueFalse";
      this.editorService.textInlineData = "";
      com.addQuestionToContent(1);
    }
    else if (state == "addTrueFalseMedia" && this.cardtype == "TrueFalse") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = TruefalsequestionComponent;
      this.popupParams.height = 210;
      this.popupParams.arrowPos = 105;
    }

    //For Multiple Choice Question
    if (state == 'addNewMultiChoice') {
      this.cardtype = "MultiChoice";
      this.editorService.textInlineData = "";
      com.addQuestionToContent(2);
    }
    else if (state == "addMultiChoiceMedia" && this.cardtype == "MultiChoice") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = MultipleselectComponent;
    }

    //For Fill up With Option  Question
    if (state == 'addNewFillupOption') {
      this.cardtype = "FillupOption";
      this.editorService.textInlineData = "";
      com.addQuestionToContent(3);
    }
    else if (state == "addFillupOptionMedia" && this.cardtype == "FillupOption") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = FillupwithoptionComponent;
    }

    if (state == "symbol") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = SymbolComponent;
    }
    if (state == "shapeColor") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = ShapecolorComponent;
      this.popupParams.height = 170;
      this.popupParams.arrowPos = 85;
    }




    if (state == "bgImgAspectRatio") {
      console.log("aspect Ratio");
      // let cardData = com.getPageData();
      // if (cardData && cardData.pageBgStyle) {
      //   var pageObj = JSON.parse(cardData.pageBgStyle)
      //   if (pageObj.type == "image" && pageObj.url) {
      //     let obj = {
      //       'type': 'image',
      //       'url': pageObj.url,
      //       'aspectRatio': true
      //     }
      //     com.setPageBackGroundStyle(obj);
      //   }
      // }
    }



    //For Media Image Card validation
    if (state == "addnewImage") {
      this.cardtype = "IMAGE";
      this.editorService.textInlineData = "";
      com.addElementsToStage('IMAGE');
    } else if (state == "imageGallery" && (this.cardtype == "IMAGE" || this.selectedOption == "image")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = ImageGallerymediaComponent;
      this.popupParams.height = 400;
      this.popupParams.width = 350;
    }
    //For Media Video Card validation
    if (state == "addnewVideo") {
      this.cardtype = "VIDEO";
      this.editorService.textInlineData = "";
      com.addElementsToStage('VIDEO');
    } else if (state == "videoGallery" && (this.cardtype == "VIDEO" || this.selectedOption == "video")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = VideogallerymediaComponent;
      this.popupParams.height = 400;
      this.popupParams.width = 350;
    }

    //For Media Card Validation
    else if (state == "addNewAudio") {
      this.cardtype = "AUDIO";
      this.editorService.textInlineData = "";
      setTimeout(() => {
        com.addElementsToStage('AUDIO');
      }, 0);

    }
    else if (state == "audioMediaConfig" && (this.cardtype == "AUDIO" || this.selectedOption == "audio")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = AudiomediaComponent;
    }

    //For Url Card
    else if (state == "addMediaurl") {
      this.cardtype = "URLLOAD";
      this.editorService.textInlineData = "";
      com.addElementsToStage('URLLOAD');
    }
    else if (state == "mediaUrlInput" && (this.cardtype == "URLLOAD" || this.selectedOption == "mediaweb")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.height = 200;
      this.popupParams.arrowPos = 90;
      this.popupParams.loadDirective = UrlComponent;
    }

    //************** For Adding the Drawing Card ************ */
    else if (state == "addDrawingCard") {
      this.cardtype = "DRAWING";
      this.drawingCardMode = true;
      this.editorService.textInlineData = "";
      com.addElementsToStage('DRAWING');
    }
    else if (state == "ebableDrawing" && (this.cardtype == "DRAWING" || this.selectedOption == "drawing")) {
      this.drawingCardMode = !this.drawingCardMode;
      if (this.drawingCardMode) {
        evt.currentTarget.style.color = '';
        evt.currentTarget.style.borderRight = '';
      } else {
        evt.currentTarget.style.color = 'rgb(84,153,249)';
        evt.currentTarget.style.borderRight = '4px solid #0286ff';
      }
      com.setDrawingCardMoveState(this.drawingCardMode);
    }
    else if (state == "configDrawing" && (this.cardtype == "DRAWING" || this.selectedOption == "drawing")) {
      this.globalPopupPara.showPopup = true;
      this.popupParams.width = 275;
      this.popupParams.loadDirective = DrawingcardcolorComponent;
    }
    else if (state == "eraseDrawing" && this.cardtype == "DRAWING") {
      com.eraseDrawingCard();
    }


    if (state == "pageNoSetting") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = PagenopositionComponent;
      this.popupParams.arrowPos = 110;
      this.popupParams.height = 220;
    }
    if (state == "pageBgColor") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = PagebackgroundcolorComponent;
      this.popupParams.height = 170;
      this.popupParams.arrowPos = 85;
    }


    if (state == "bgImgGallery") {
      this.globalPopupPara.showPopup = true;
      this.popupParams.loadDirective = MediacategoriesComponent;
      this.popupParams.height = 400;
      this.popupParams.width = 350;
    }


    this.cdr.detectChanges();

  }
  //************* For Undo The Changes **************
  undoChanges() {
    let com = this.editorService.getIframeReference();
    com.makeUndo();
  }
  //************* For Redo The Changes **************
  redoChanges() {
    let com = this.editorService.getIframeReference();
    com.makeRedo();
  }
  //************* For Switching to Live **************
  showLivePreview() {
    this.toogleLivePreciew = !this.toogleLivePreciew;
    this.exitToLevelFirst();
    let layer = this.editorService.getIframeReference();
    layer.setDrawingCardMoveState(false);
    layer.showLivePreview();
  }

  //************* For Saving the Template **************
  // saveTemplate() {
  //   let com = this.editorService.getIframeReference();
  //   var pageContent = com.savePage();
  //   if (this.bookObj.bookCategory == 1 && this.rootTabActive)
  //     this.editorOptionsService.savePageContent(this.pageObj.contentDocId, pageContent);
  //   else
  //     this.editorOptionsService.savePageContent(this.currentLoadingPage.contentDocId, pageContent);
  // }

  //************ For Switching to preview ***************
  SwitchToPreview() {
    this.toogleLivePreciew = false;
    let com = this.editorService.getIframeReference();
    //com.savePage();
    this.editorService.getEditorData('pagePreview');
    this.exitToInitialState();
  }

  //************ Exit to Initial state ***************
  exitToInitialState() {
    this.displayAddMoreComp = false;
    this.gotoBack = undefined;
    this.selectedOption = undefined;
    this.moreIconsList = this.tempMoreIconsList;
  }

  exitToLevelFirst() {
    this.displayAddMoreComp = true;
    this.gotoBack = undefined;
    this.updatedIcon = "icon-CollectionTemplatesL";
    this.selectedOption = undefined;
    this.moreIconsList = this.tempMoreIconsList;
  }
  //********** For Showing the Dialog box ************
  showCardAlert(evt, state) {
    this.dialogData = state;
    this.showAlertPopup = true;
    this.cdr.detectChanges();
  }
  hideAlertPopup(evt) {
    if (evt == undefined) {
      this.showAlertPopup = false;
    } else {
      evt.stopPropagation();
    }
    this.cdr.detectChanges();
  }
  //For Opening the popup 
  openPopupFromObj(data) {
    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.ev = '';
    this.globalPopupPara.showPopup = true;
    this.popupParams.iconposObj = {};


    if (data.type == "Image") {
      this.popupParams.height = 400;
      this.popupParams.width = 350;
      let currentPos = this.ele.nativeElement.querySelector('.textMediaImageConfig');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = TextimageComponent;
      }
    }

    else if (data.type == "Inline Image") {
      this.popupParams.height = 400;
      this.popupParams.width = 350;
      let currentPos = this.ele.nativeElement.querySelector('.textMediaInlineImageConfig');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = InlineimageComponent;
      }
    }
    //addFillupMedia
    else if (data.type == "FillBlank") {
      this.popupParams.height = 200;
      let currentPos = this.ele.nativeElement.querySelector('.addFillupMedia');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = FillupquestionComponent;
      }
    }
    // addTrueFalseMedia
    else if (data.type == "TrueFalse") {
      this.popupParams.height = 210;
      this.popupParams.arrowPos = 105;
      let currentPos = this.ele.nativeElement.querySelector('.addTrueFalseMedia');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = TruefalsequestionComponent;
      }
    }
    // multipleSelect
    else if (data.type == "MultiSelect") {
      let currentPos = this.ele.nativeElement.querySelector('.addMultiChoiceMedia');
      if (currentPos) {
        this.popupParams.width = 300;
        this.popupParams.height = 350;
        this.popupParams.arrowPos = 175;
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = MultipleselectComponent;
      }
    }
    // select
    else if (data.type == "Select") {
      let currentPos = this.ele.nativeElement.querySelector('.addFillupOptionMedia');
      if (currentPos) {
        this.popupParams.width = 300;
        this.popupParams.height = 350;
        this.popupParams.arrowPos = 175;
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = FillupwithoptionComponent;
      }
    }
    else if (data.type == "IMAGE") {
      this.popupParams.height = 400;
      this.popupParams.width = 350;
      let currentPos = this.ele.nativeElement.querySelector('.imageGallery');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = ImageGallerymediaComponent;
        this.cdr.detectChanges();
      }
    }
    else if (data.type == "VIDEO" || data.type == "VIDEOYT") {
      this.popupParams.height = 400;
      this.popupParams.width = 350;
      let currentPos = this.ele.nativeElement.querySelector('.videoGallery');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = VideogallerymediaComponent;
        this.cdr.detectChanges();
      }
    }
    else if (data.type == "AUDIO") {
      this.popupParams.height = 350;
      this.popupParams.width = 300;
      let currentPos = this.ele.nativeElement.querySelector('.audioMediaConfig');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = AudiomediaComponent;
        this.cdr.detectChanges();
      }
    }
    else if (data.type == "URLLOAD") {
      this.popupParams.height = 200;
      this.popupParams.arrowPos = 90;
      let currentPos = this.ele.nativeElement.querySelector('.mediaUrlInput');
      if (currentPos) {
        this.assignPosition(currentPos, this.popupParams.width, this.popupParams.height);
        this.popupParams.loadDirective = UrlComponent;
        this.cdr.detectChanges();
      }
    }
  }


  assignPosition(currentPos, wdt, hgt) {
    if (wdt == undefined) {
      wdt = this.popupParams.height;
    }
    let scrollDiv = document.getElementsByClassName('pdfBookViewCon')[0];
    if (this.bookObj.bookCategory == 1 && this.bookObj.bookType == 3) {
      scrollDiv = document.getElementsByClassName('eLessonConView')[0];
    }
    let popoupTopVal, popoupLeftVal;

    popoupTopVal = currentPos.offsetTop - scrollDiv.scrollTop - hgt * 0.5 + 'px';
    popoupLeftVal = currentPos.offsetLeft - scrollDiv.scrollLeft - wdt - 10 + 'px';
    this.popupParams.iconposObj.iconPosTop = popoupTopVal;
    this.popupParams.iconposObj.iconPosLeft = popoupLeftVal;
    this.popupParams.iconposObj.iconPosArrowTop = currentPos.offsetTop - scrollDiv.scrollTop + 'px';
    this.popupParams.iconposObj.iconPosArrowLeft = currentPos.offsetLeft - scrollDiv.scrollLeft - 20 + 'px';
    if (currentPos.offsetLeft < wdt) {
      popoupLeftVal = currentPos.offsetLeft - scrollDiv.scrollLeft + 35 + 'px';
      this.popupParams.iconposObj.iconPosLeft = popoupLeftVal;
      this.popupParams.iconposObj.iconPosArrowLeft = currentPos.offsetLeft - scrollDiv.scrollLeft + 25 + 'px';
    }
  }
  // setPageConent(data) {
  //   this.editorOptionsService.applyPageBgStyleToAllPages(data.pageContent, this.bookDataObj);
  // }

}






//************************* Component for loading the dialog Template ******************** */
@Component({
  selector: 'bookeditalertdialog',
  templateUrl: 'bookeditalertdialog.html',
})
export class DialogOverviewExampleDialog {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}





// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookeditoption.component.ts